import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { PageLayout } from '../account/layout/PageLayout';

import { GameIds } from '../account/my-games/MyGames.model';
import { ProvidePromotion } from '../account/promotion/PromotionContext';
import { useAuth } from '../authentication/AuthenticationContext';
import { useConfig } from '../ConfigContext';
import { RequestError } from '../Error.model';
import { useSnackbar } from '../snackbar/SnackbarContext';
import { request } from '../utils/Request';
import { ActivatePromotion } from './Activation.model';
import { ActivationClaim } from './step/ActivationClaim';
import { ActivationConnected } from './step/ActivationConnected';
import { ActivationLink } from './step/ActivationLink';
import { ActivationNotConnected } from './step/ActivationNotConnected';

enum Step {
  Initial,
  Link,
  Claim,
}

export function Activation(): JSX.Element {
  const { user } = useAuth();
  const location = useLocation();
  const history = useHistory();
  const snackbar = useSnackbar();
  const config = useConfig();

  const [step, setStep] = useState<Step>(Step.Initial);
  const [provider, setProvider] = useState<string | null>(null);
  const [promotions, setPromotions] = useState<ActivatePromotion[]>([]);
  const { gameId }: { gameId: GameIds } = useParams();

  const getPromotions = async (): Promise<void> => {
    try {
      const response = await request<ActivatePromotion[]>(
        'GET',
        `${config.clientConfig.host}/promotions?requiredGameIds=${gameId}`,
        {
          disableRedirect: true,
        },
      );
      setPromotions(response);
    } catch (e) {
      const err = e as RequestError;
      snackbar.addErrorMessage(err.code);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const providerParam = searchParams.get('provider');

    if ((gameId !== GameIds.HOY && gameId !== GameIds.FM) || providerParam !== 'steam') {
      history.push('/');
    }

    setProvider(providerParam);
  }, []);

  useEffect(() => {
    if (gameId) {
      getPromotions();
    }
  }, [gameId]);

  return (
    <PageLayout hideMenu disableTransitions>
      <ProvidePromotion>
        <div className={`activation-wrapper ${gameId}`}>
          <div className='activation-container'>

            {!user && (
              <ActivationNotConnected
                gameId={gameId}
                promotions={promotions}
              />
            )}

            {user && step === Step.Initial
        && (
          <ActivationConnected
            goToLink={() => { setStep(Step.Link); }}
            provider={provider}
            gameId={gameId}
            promotions={promotions}
          />
        )}

            {step === Step.Link
        && (
          <ActivationLink
            goToClaim={() => { setStep(Step.Claim); }}
            provider={provider}
            gameId={gameId}
            promotions={promotions}
          />
        )}

            {step === Step.Claim
        && (
          <ActivationClaim promotions={promotions} />
        )}
          </div>
        </div>
      </ProvidePromotion>
    </PageLayout>
  );
}
